import { ShowModal } from "@/react/components/FormRendererV2/ShowModal";
import { useGetForm } from "@/react/components/SettingsApp/Emails/components/Forms/hooks/useGetForm";
import type { FormEmbedDisplayFormat } from "@/react/types/Form";
import { FormContent } from "./FormContent";
import type { RenderType } from "./contexts/FormRenderingContext";
import { FormRenderingProvider } from "./contexts/FormRenderingContext";
import { useAdjustFormHeight } from "./hooks/useAdjustFormHeight";

interface FormRendererV2Props {
  embedDisplayFormat?: FormEmbedDisplayFormat;
  id: number;
  index: number;
  isPreview?: boolean;
  isUsedOnPages?: boolean;
  popupDelay?: number;
  popupFrequency?: number;
  renderType?: RenderType;
}
export const FormRendererV2 = ({
  id,
  index,
  isPreview = false,
  isUsedOnPages = false,
  embedDisplayFormat,
  popupFrequency,
  popupDelay,
  renderType = "embed",
}: FormRendererV2Props) => {
  const { data: form, isLoading } = useGetForm({ id });
  const formDisplayFormat = isUsedOnPages
    ? "inline"
    : (embedDisplayFormat ?? form?.embed_display_format);
  const isModal = formDisplayFormat === "popup" && renderType === "embed";
  const RenderingComponent = isModal ? ShowModal : FormContent;

  useAdjustFormHeight({ form, index, isModal });

  if (isLoading || !form) {
    return null;
  }

  return (
    <FormRenderingProvider
      form={form}
      index={index}
      isModal={isModal}
      isPreview={isPreview}
      isUsedOnPages={isUsedOnPages}
      popupDelay={popupDelay}
      popupFrequency={popupFrequency}
      renderType={renderType}
    >
      <RenderingComponent />
    </FormRenderingProvider>
  );
};
